<template>
  <v-footer color="primary" dark height="40" app>
    <v-row no-gutters justify="space-between" align="center" class="footer-content">
      <v-col cols="auto" class="my-2">
        <span>
          {{ $t('footer.copyright') }} {{ new Date().getFullYear() }}
        </span>
        <span>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">沪ICP备2021011710号-1</a>
        </span>
      </v-col>
      <v-col cols="auto" class="my-2">
        <span><v-icon color="blue">mdi-phone</v-icon>+86-021-50917571</span>
        <span><v-icon color="yellow">mdi-map-marker</v-icon>{{ $t('footer.address') }}</span>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>
.v-footer {
  font-size: 0.9rem;
}

.v-footer a {
  color: inherit;
  text-decoration: none;
}

.v-footer span {
  margin-right: 10px;
}

.v-icon {
  size: x-small;
  margin-right: 2px;
}
</style>